import { render, staticRenderFns } from "./addEmloyees.vue?vue&type=template&id=f4a3bbb6&scoped=true"
import script from "./addEmloyees.vue?vue&type=script&lang=js"
export * from "./addEmloyees.vue?vue&type=script&lang=js"
import style0 from "./addEmloyees.vue?vue&type=style&index=0&id=f4a3bbb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a3bbb6",
  null
  
)

export default component.exports